import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, provide, inject, createRef, onUnmounted } from 'intact-vue';
import template from './menu.vdt';
import { bind } from '../utils';
import { DROPDOWN } from './dropdown';
import { useTransition } from './useTransition';
import { useMenuKeyboard } from './useKeyboard';
import { useMouseOutsidable } from '../../hooks/useMouseOutsidable';
import { useConfigContext } from '../config';
import { usePositionForDropdownMenu } from './usePosition';
export var DROPDOWN_MENU = 'DropdownMenu';
export var DropdownMenu = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DropdownMenu, _Component);
  function DropdownMenu() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.dropdown = inject(DROPDOWN);
    _this.keyboard = useKeyboardForDropdownMenu(_this.dropdown);
    _this.transition = useTransition(function (callback) {
      return _this.dropdown.position(callback);
    });
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = DropdownMenu.prototype;
  _proto.init = function init() {
    provide(DROPDOWN_MENU, this);
    useMouseOutsidable(this.elementRef);
    usePositionForDropdownMenu();
  }
  // no matter what the trigger is, we should show menu when enter into it.
  ;
  _proto.onMouseEnter = function onMouseEnter(e) {
    var dropdown = this.dropdown;
    dropdown.show();
    dropdown.trigger('mouseenter', e);
  };
  _proto.onMouseLeave = function onMouseLeave(e) {
    var dropdown = this.dropdown;
    dropdown.hide();
    dropdown.trigger('mouseleave', e);
  };
  return DropdownMenu;
}(Component);
DropdownMenu.template = template;
__decorate([bind], DropdownMenu.prototype, "onMouseEnter", null);
__decorate([bind], DropdownMenu.prototype, "onMouseLeave", null);
function useKeyboardForDropdownMenu(dropdown) {
  var parentDropdownMenu = inject(DROPDOWN_MENU, null);
  var _useMenuKeyboard = useMenuKeyboard(),
    _useMenuKeyboard$ = _useMenuKeyboard[0],
    addKeydown = _useMenuKeyboard$[0],
    removeKeydown = _useMenuKeyboard$[1],
    lock = _useMenuKeyboard$[2],
    focusByIndex = _useMenuKeyboard[1],
    reset = _useMenuKeyboard[2];
  var onShow = function onShow() {
    addKeydown();
    // lock parent dropdown menu, prevent it from operating by keyboard
    parentDropdownMenu && parentDropdownMenu.keyboard.lock(true);
  };
  var onHide = function onHide() {
    reset();
    removeKeydown();
    parentDropdownMenu && parentDropdownMenu.keyboard.lock(false);
  };
  var focus = function focus() {
    return focusByIndex(0);
  };
  // In Cascader the menu may have been replaced by another menu, in this case,
  // if the dropdown has showed while we mounted the menu, add the keydown listener
  if (dropdown.get('value')) {
    onShow();
  }
  dropdown.on('show', onShow);
  dropdown.on('hide', onHide);
  dropdown.on('shouldFocus', focus);
  onUnmounted(function () {
    dropdown.off('show', onShow);
    dropdown.off('hide', onHide);
    dropdown.off('shouldFocus', focus);
  });
  return {
    lock: lock
  };
}